import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-refunds-or-cancellations',
  templateUrl: './refunds-or-cancellations.component.html',
  styleUrls: ['./refunds-or-cancellations.component.scss']
})
export class RefundsOrCancellationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
